// extracted by css-extract-rspack-plugin
export default {"markdownHeroContainer":"Readme-module__markdownHeroContainer__LRmMNl2","markdownHeroLogo":"Readme-module__markdownHeroLogo__RZimSlr"};